import React from "react";
import Widgets from "../../HomeCards/Card";
import CurrencyFormat from "react-currency-format";
import moment from "moment";

const StockTotal = (props) => {
  return (
    <Widgets
      icon="stats"
      currency={`Tümü`}
      title="Toplam Stok Sayısı"
      totalBalance={
        <CurrencyFormat
          value={props?.data}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          prefix={""}
        />
      }
    />
  );
};

export default StockTotal;
